module.exports = __webpack_public_path__ + "img/10001.6caff192.jpg";